import React from 'react';
import Select from './Select';

interface Props {
    currentLanguage: string;
    handleChangeLanguage: (lang: string) => void;
    languageList: string[];
    style?: any;
}

const LanguageSelect: React.FC<Props> = ({
    currentLanguage,
    handleChangeLanguage,
    languageList,
    style,
}) => {
    return (
        <Select
            value={currentLanguage}
            setFieldValue={handleChangeLanguage}
            selectItems={languageList}
            style={style}
        />
    );
};

export default LanguageSelect;
